// NotaLivro.js — Estrelas + nota de um livro, do jeito que o site inteiro mostra.
//
// Existe para que catálogo, home, quick view, "compre junto" e minha lista não
// tenham cada um a sua versão da mesma linha. Quem decide QUAL nota mostrar é
// o `notaExibida.js`; este arquivo só desenha.
//
// A nota vem SEMPRE junto com o livro (`avaliacoes_avg_nota` e
// `avaliacoes_count`, que o backend manda em todo endpoint de livro). Nenhum
// card busca a própria nota: seriam 198 requisições no catálogo, contra um
// MySQL com limite de conexões.
import React from "react";
import Stars from "./Stars";
import { notaDoLivro } from "./notaExibida";

/**
 * @param livro     objeto do livro vindo da API
 * @param size      classe de tamanho de fonte das estrelas
 * @param mostrarTexto  escreve "4,5 (12)" / "sem avaliações" ao lado
 * @param compacto  só o número, sem o "(12)" — para espaços apertados
 */
const NotaLivro = ({
  livro,
  size = "text-xs",
  mostrarTexto = true,
  compacto = false,
  className = "",
}) => {
  const { nota, total, semAvaliacoes, atenuada, texto } = notaDoLivro(livro);

  // Sem avaliação, as estrelas ficam apagadas: mostram as 5 posições sem
  // afirmar que alguém deu nota máxima. Ver o cabeçalho de notaExibida.js.
  return (
    <span
      className={"inline-flex items-center gap-1.5 " + className}
      title={semAvaliacoes ? "Este livro ainda não tem avaliações" : `${texto} avaliações`}
    >
      <Stars value={nota} size={size} className={atenuada ? "opacity-40" : ""} />
      {mostrarTexto && (
        <span className={"text-white/45 " + size}>
          {semAvaliacoes
            ? "sem avaliações"
            : compacto
            ? nota.toFixed(1).replace(".", ",")
            : `${nota.toFixed(1).replace(".", ",")} (${total})`}
        </span>
      )}
    </span>
  );
};

export default NotaLivro;
